import React, { useContext, useEffect, useRef } from "react";
import { Box, Typography, Avatar } from "@mui/material";
import { Link } from "react-router-dom";
import { PerformerContext } from "../contexts/PerformerContext";

const RightSidebar = () => {
  const { performers } = useContext(PerformerContext);
  const bannerRef = useRef(null);

  // Inject TwinRed adlib.js properly — React strips <script> tags in JSX
  useEffect(() => {
    if (!bannerRef.current) return;
    // Clear and re-inject so script executes
    bannerRef.current.innerHTML = '';
    const ins = document.createElement('ins');
    ins.setAttribute('data-tr-zone', '01DXF6DT004000000000002PRX');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://s.ad.twinrdengine.com/adlib.js';
    ins.appendChild(script);
    bannerRef.current.appendChild(ins);
  }, []);

  // Show top 20 performers
  const top = (performers || []).slice(0, 20);

  return (
    <Box sx={{
      width: 280, display: "flex", flexDirection: "column",
      alignItems: "center", gap: 2, pt: 1,
      position: "sticky", top: 16,
      // On landscape (short viewport), don't cap height so ads aren't clipped
      maxHeight: { md: "calc(100vh - 32px)" },
      overflowY: "auto",
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": { width: 4 },
      "&::-webkit-scrollbar-track": { background: "transparent" },
      "&::-webkit-scrollbar-thumb": { background: "#444", borderRadius: 2 },
    }}>

      {/* Cambuilder Live Model embed — FIRST so it's always visible */}
      <Box sx={{ width: 300, flexShrink: 0 }}>
        <iframe
          src="https://as.sexad.net/as/if?p=reseller&w=1&h=1&v=9933&adHeight=250&adWidth=300&adType=live&autoplay=false&showvideo=false&hn=instacamgirls.net&AFNO=1-ICGcom"
          allowTransparency={true}
          width="300"
          height="250"
          style={{ maxWidth: "100%", border: "none", display: "block" }}
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          scrolling="no"
          title="Live Models"
        />
      </Box>

      {/* Twinred NTV A banner — second ad unit, always visible */}
      <Box ref={bannerRef} sx={{ width: 300, minHeight: 250, flexShrink: 0 }} />

      {/* Top Performers — below ads, hidden on landscape to keep ads visible */}
      {top.length > 0 && (
        <Box sx={{
          width: "100%",
          // Hide performer list on landscape phones (short viewport) so ads stay visible
          "@media (max-height: 500px)": { display: "none" },
        }}>
          <Typography sx={{ fontWeight: 800, fontSize: "0.85rem", color: "#FF4196", mb: 1, textTransform: "uppercase", letterSpacing: 1 }}>
            🔴 Live Now
          </Typography>
          {top.map(p => (
            <Box key={p.uniqueModelId}
              component={Link}
              to={`/cam/${p.displayName}`}
              sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5,
                textDecoration: "none", color: "inherit",
                "&:hover": { "& .pname": { color: "#FF4196" } } }}>
              <Avatar
                src={p.profilePictureUrl}
                alt={p.displayName}
                sx={{ width: 42, height: 42, border: "2px solid #FF4196", flexShrink: 0 }}
              />
              <Box sx={{ overflow: "hidden" }}>
                <Typography className="pname" sx={{ fontWeight: 700, fontSize: "0.82rem",
                  whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                  transition: "color 0.15s" }}>
                  {p.displayName}
                </Typography>
                <Typography sx={{ fontSize: "0.72rem", color: "#4CAF50" }}>
                  ● Live
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}

    </Box>
  );
};

export default RightSidebar;
